import React from 'react';

// import icons
import IconCross from 'js/components/icon/Icon.cross';

const ButtonBackCross = ({ action }) => {
  return (
    <button className={'button--back'} onClick={action} aria-label="Back" id="back-button">
      <IconCross />
    </button>
  );
};

export default ButtonBackCross;
